/**
 * Module errors.
 *
 * @module
 */
/** The provided on chain config bytes are empty or invalid */
export const EINVALID_CONFIG = {
  code: 1,
  name: "EINVALID_CONFIG",
  doc: "The provided on chain config bytes are empty or invalid",
} as const;
